import { ElementRef, Injectable } from '@angular/core';
import { FeatureForbiddenReason } from '@/app/platform/platform-context/platform-navigation.context';

@Injectable({
  providedIn: 'root'
})
export class FeatureElementAccessToggler {
  constructor() {}

  disable(el: ElementRef<HTMLElement>): void {
    el.nativeElement.classList.add('feature-disabled');
    // @ts-ignore
    el.nativeElement.disabled = true;
  }

  enable(el: ElementRef<HTMLElement>): void {
    el.nativeElement.classList.remove('feature-disabled');

    // @ts-ignore
    el.nativeElement.disabled = false;
  }

  showUnauthorizedOverlay(
    el: ElementRef<HTMLElement>,
    featureName: string,
    reasons: FeatureForbiddenReason[]
  ): void {
    if (el.nativeElement.classList.contains('overlay')) {
      return;
    }
    const element = document.createElement('div');
    element.classList.add('overlay');
    element.classList.add('justify-content-start');
    element.classList.add('p-3');
    element.classList.add('text-secondary');

    element.innerHTML = `
        <div>U hebt geen toegang tot de functionaliteit '${featureName}:'</div>
`;
    const reasonsUl = document.createElement('ul');
    reasonsUl.style.listStylePosition = 'inside';
    reasons.forEach(r => {
      const li = document.createElement('li');

      if (r.type === 'Unauthorized') {
        li.innerHTML = 'U hebt niet de juiste rechten.';
      }
      if (r.type === 'IncorrectDeviceType') {
        li.innerHTML =
          'U bevindt zich niet op een toestel van een van volgende types: <br> ' +
          r.requirementsList;
      }

      reasonsUl.appendChild(li);
    });

    element.appendChild(reasonsUl);
    el.nativeElement.appendChild(element);
  }

  hideUnauthorizedOverlay(el: ElementRef<HTMLElement>): void {
    const overlay = el.nativeElement.querySelector('.overlay');

    if (overlay) {
      el.nativeElement.removeChild(overlay);
    }
  }
}
